import { render, staticRenderFns } from "./ChangeOptIn.vue?vue&type=template&id=07297b18&scoped=true"
import script from "./ChangeOptIn.vue?vue&type=script&lang=js"
export * from "./ChangeOptIn.vue?vue&type=script&lang=js"
import style0 from "./ChangeOptIn.vue?vue&type=style&index=0&id=07297b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07297b18",
  null
  
)

export default component.exports